// extracted by mini-css-extract-plugin
export default {"commonLabel":"CalculationCommonLabel_commonLabel__4YHE9","commonLabelB":"CalculationCommonLabel_commonLabelB__82Rm4","commonInput":"CalculationCommonLabel_commonInput__yNvL2"};